<template>
  <div class="p-2 text-left fw-bold rounded border border-white" :style="`background-color: ${backgroundColor}; color: ${textColor};`">
    <div class="d-flex justify-content-between">
      <div class="text-sm-secondary">
        <Popper placement="right" @open:popper="fetchVehicle">
          <span class="p-1" role="button">
            <span>
              {{ trailer.plateNumber }}
            </span>
            <span v-if="hidden"> (UKRYTA) </span>
          </span>

          <template #content>
            <button
              v-if="vehicle"
              class="btn btn-danger"
              data-bs-toggle="modal"
              data-bs-target="#selectTrailerParkingModal"
              @click="launchSelectTrailerParkingModal">
              Odepnij naczepę
            </button>
            <br>
            <div>
              <button class="btn btn-danger mt-2" @click="deleteTrailer">
                Usuń naczepę
              </button>
              <br>
              <Popper placement="right">
                <button class="btn btn-primary mt-2">
                  Edytuj naczepę
                </button>
                <template #content>
                  <br>
                  <form @submit.prevent="UpdateTrailer">
                    <input type="text" placeholder="Nazwa" class="w-200" v-model="plateNumber">
                    <button class="mt-2 btn btn-primary" type="submit">
                      Zapisz
                    </button>
                  </form>
                </template>
              </Popper>
            </div>
          </template>
        </Popper>
        <br>
        <span v-for="commentarz in trailer.comments" :key="commentarz" style="cursor:pointer;">
          <Popper placement="right">
            <span
              class="text-xs rounded-1 px-1 mr"
              :style="`background-color: ${commentarz.backgroundColor ?? '#ffffff'}; color: ${commentarz.textColor ?? '#000000'}; margin-left: 2px; font-size:1em;`"
            >
              {{commentarz.title}}
            </span>
            <template #content>
              <h6> komentarz: {{commentarz.title}}</h6>
              <p v-html="handleNewLine(commentarz.content)"></p>
              <button class="btn btn-danger" @click="deleteComment(commentarz.id)">
                usuń komentarz
              </button>
              <CommentEdit
                :comment="commentarz"
                style="float: left; text-align: center;"
              />
            </template>
          </Popper>
        </span>
      </div>
      <div class="text-xl">
        <Popper placement="right">
          <span class="text-darker px-1" role="button">
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </span>
          <template #content>
            <CommentCreator :vehicle-id="null" :trailer-id="trailer.id" />
            <div class="text-sm my-2" role="button" @click="changeTrailerVisibility(true)" v-if="!hidden">
              Ukryj naczepę
            </div>
            <div class="text-sm my-2" role="button" @click="changeTrailerVisibility(false)" v-else>
              Wyłącz ukrywanie naczepy
            </div>
            <div class="text-sm mt-2 user-select-none">
              Kolor czcionki
              <div class="colorsPallete">
                <div
                  v-for="(color, index) in colors"
                  :key="index"
                  class="mx-1 px-1 border border-1 d-inline"
                  role="button"
                  :style="`background-color: ${color};`"
                  @click="changeColor('text', color)"></div>
              </div>
            </div>
            <div class="text-sm mt-2 user-select-none">
              Kolor komórki
              <div>
                <div class="colorsPallete">
                  <div
                    v-for="(color, index) in colors"
                    :key="index"
                    class="mx-1 px-1 border border-1 d-inline"
                    role="button"
                    :style="`background-color: ${color};`"
                    @click="changeColor('background', color)"></div>
                </div>
              </div>
            </div>
          </template>
        </Popper>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import CommentEdit from '@/components/CommentEdit.vue'
import CommentCreator from '@/components/TasksCalendar/Comments/Trailer/CommentCreator.vue'
import axios from 'axios'
import Swal from 'sweetalert2'
import emitter from '@/modules/events/emitter'
import colors from '@/modules/cells/colors'
import Popper from 'vue3-popper'
import eventKinds from '@/modules/events/eventKinds'
import { $axios } from '@/modules/http/axios'

export default defineComponent({
  name: 'TrailerCell',
  props: ['trailer'],
  components: {
    CommentCreator,
    Popper,
    CommentEdit
  },
  data () {
    return {
      axiosConfig: { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } },
      colors: colors,
      textColor: this.trailer.textColor,
      backgroundColor: this.trailer.backgroundColor,
      plateNumber: this.trailer.plateNumber,
      hidden: this.trailer.hidden,
      vehicle: null
    }
  },
  created () {

  },
  computed: {
    mailings () {
      return this.$store.getters.getCalendarMailings
    }
  },

  methods: {
    fetchVehicle () {
      $axios.get('Vehicle').then(response => {
        response.data.map(v => {
          if (v.semiTrailer?.plateNumber === this.trailer.plateNumber) {
            this.vehicle = v
          }
        })
      })
    },
    async changeColor (colorType, colorHex) {
      if (colorType === 'text') {
        this.textColor = colorHex
      } else if (colorType === 'background') {
        this.backgroundColor = colorHex
      }

      const putData = {
        textColor: this.textColor,
        backgroundColor: this.backgroundColor,
        plateNumber: this.plateNumber
      }

      await axios.put(`${process.env.VUE_APP_API_BASE_URL}Trailer/${this.trailer.id}`, putData, this.axiosConfig)
    },

    async detachTrailer () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      const vehicle = this.vehicle ?? this.altVehicle

      try {
        let parkings = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}Parking`, config)).data

        parkings = parkings.filter((parking) => {
          return !parking.hidden
        })

        const inputOptions = []
        parkings.forEach(parking => {
          inputOptions.push(parking.name)
        })
        await Swal.fire({
          title: 'Wybierz docelowy parking dla naczepy',
          input: 'select',
          required: true,
          icon: 'info',
          showCancelButton: true,
          cancelButtonText: 'Anuluj',
          inputOptions: inputOptions
        }).then(input => {
          if (input.value) {
            const parking = parkings[input.value]
            const postData = {
              semitrailerId: this.trailer.id,
              parkingId: parking.id
            }
            axios.post(`${process.env.VUE_APP_API_BASE_URL}Vehicle/Vehicle/${vehicle.id}/Semitrailer/Unassign`, postData, config).then(() => {
              Swal.fire(`Odpięto naczepę od ciągnika ${vehicle.plateNumber}`, '', 'success')
              emitter.emit('vehicleChanged', { vehicleId: this.trailer.id })
              emitter.emit('trailerDetached')
            })
          } else {
            Swal.fire('Nie podano parkingu', '', 'error')
          }
        })
      } catch (e) {
        console.log(e)
        await Swal.fire('Coś poszło nie tak', '', 'error')
      }
    },

    async changeTrailerVisibility (bool) {
      this.hidden = bool

      const putData = {
        hidden: this.hidden
      }

      try {
        await axios.put(`${process.env.VUE_APP_API_BASE_URL}Trailer/${this.trailer.id}`, putData, this.axiosConfig)
        await Swal.fire('Sukces', 'Pomyślnie wykonano akcję.', 'success')
        emitter.emit('trailerVisibilityChanged', { trailerId: this.trailer.id })
      } catch (e) {
        await Swal.fire('Nie udało się zmienić widoczności naczepy', '', 'error')
        console.log(e)
      }
    },

    async deleteTrailer () {
      const dialogResult = await Swal.fire({
        title: `Czy na pewno chcesz usunąć naczepę ${this.plateNumber} ?`,
        text: 'Usunięcie naczepy spowoduje usunięcie wszystkich komentarzy i etykiet.',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Tak',
        cancelButtonText: 'Nie',
        icon: 'question'
      })

      if (dialogResult.isConfirmed) {
        try {
          await axios.delete(`${process.env.VUE_APP_API_BASE_URL}Trailer/${this.trailer.id}`, this.axiosConfig)
          await Swal.fire(`Usunięto naczepę ${this.plateNumber}`, `Naczepa ${this.plateNumber} została usunięta z systemu`, 'success')
        } catch (e) {
          await Swal.fire(`Nie udało się usunąć naczepy ${this.plateNumber}`, `System nie był w stanie usunąć naczepy ${this.plateNumber}. <br> <span class="fw-bold">Kod błędu: ${e.response.status}</span>`, 'error')
        }
      }
    },
    handleNewLine (str) {
      return str.replace(/(?:\r\n|\r|\n)/g, '<br />')
    },
    AddComment () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

      const postdata = {
        title: this.comment.title,
        textColor: this.comment.textColor,
        backgroundColor: this.comment.backgroundColor,
        content: this.comment.content,
        MailNotificationRecipients: this.comment.mails.split(','),
        sendNotificationOn: this.comment.sendNotificationOn
      }

      axios.post(process.env.VUE_APP_API_BASE_URL + 'Comment/Semitrailer/' + this.trailer.id, postdata, config)
        .then(() => {
          Swal.fire({
            title: 'Komentarz dodany',
            text: 'Komentarz został dodany',
            type: 'success',
            confirmButtonText: 'OK'
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    deleteComment (id) {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      axios.delete(process.env.VUE_APP_API_BASE_URL + 'Comment/' + id, config)
        .then(response => {
          Swal.fire({
            title: 'Komentarz usunięty',
            text: 'Komentarz został usunięty',
            icon: 'success',
            confirmButtonText: 'OK'
          })

          emitter.emit('trioCommentModified')
          emitter.emit('refreshed')
        })
        .catch(error => {
          console.log(error)
        })
    },
    UpdateTrailer () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      const postdata = this.trailer

      postdata.plateNumber = this.plateNumber

      axios.put(`${process.env.VUE_APP_API_BASE_URL}Trailer/${this.trailer.id}`, postdata, config)
        .then(() => {
          Swal.fire({
            title: 'Naczepa zaktualizowana',
            text: 'Naczepa została zaktualizowana',
            type: 'success',
            confirmButtonText: 'OK',
            icon: 'success'
          })
          this.$emit('delete', this.id)
        })
        .catch(error => {
          console.log(error)
          Swal.fire({
            title: 'Błąd',
            text: 'Nie udało się zaktualizować naczepy. Proszę sprawdzić wszystkie pola',
            type: 'error',
            confirmButtonText: 'OK',
            icon: 'info'
          })
        })
    },
    launchSelectTrailerParkingModal () {
      emitter.emit(eventKinds.selectTrailerParkingModalRequested, { vehicle: this.vehicle, trailer: this.trailer })
    },
  }
})
</script>

<style scoped>
.text-left {
  text-align: left;
}
.text-sm {
  font-size: .8rem;
}
.text-sm-secondary {
  font-size: .6rem;
}
.text-xs {
  font-size: .5rem;
}
.text-xl {
  font-size: 1.2rem;
}
.text-darker {
  color: #bbb;
}
.bg-light-green {
  background-color: #47d147;
}
.mh-45 {
  min-height: 45px;
}

.w-200 {
  width: 200px;
  height: 25px
}
</style>
